import {EntityModel} from "@fedeltapointofsale/data-client";
import {ManufacturerData} from "./manufacturer.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class ManufacturerEntityModel extends EntityModel<ManufacturerData> {

    constructor(injector: Injector) {
        super(injector, ManufacturerData);
    }
}
